import ApplicationController from 'javascript/controllers/application_controller';

export default class NewTabsController extends ApplicationController {
  connect() {
    this.tabIdentifier = this.element.dataset?.tabIdentifier;
    this.isSeatingPlan = this.element.dataset?.isSeatingPlan === 'true';
    this.setActiveTab();
  }

  setActiveTab = async (clickEvent) => {
    if (this.isSeatingPlan) clickEvent?.preventDefault();

    this.activeTabElement?.classList.remove('active');

    let newActiveTab;

    if (clickEvent) {
      newActiveTab = clickEvent.currentTarget.parentNode;
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const tabId = urlParams.get(this.tabIdentifier);

      if (tabId) {
        newActiveTab = document.querySelector(`.tab-${tabId}`);
      } else {
        newActiveTab = this.element.ownerDocument.querySelector(
          '.category-tabs__tab',
        );
      }
    }

    if (!newActiveTab) return;

    this.activeTabElement = newActiveTab;
    newActiveTab.classList.add('active');

    this.scrollActiveTabIntoView();

    if (this.isSeatingPlan) {
      const zoomEvent = new CustomEvent('seating-plan-zoom-event', {
        bubbles: true,
        detail: { category: newActiveTab.dataset.tabName },
      });
      this.element.dispatchEvent(zoomEvent);
    }
  };

  scrollActiveTabIntoView = () => {
    this.activeTabElement.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
    });
  };
}
